export const SMUIN_ORGANIZATION_NAME = 'Smuin Contemporary Ballet';

export function isSmuinEvent(event) {
  const evidence = [
    event?.['Event Name'],
    event?.Description,
    event?.EventURL,
    event?.manualProgramId,
  ]
    .filter(Boolean)
    .join(' ');
  return /\bsmuin\b/i.test(evidence);
}
export function getEventOrganizationName(event) {
  if (isSmuinEvent(event)) return SMUIN_ORGANIZATION_NAME;
  return typeof event?.OrganizerName === 'string' ? event.OrganizerName.trim() : '';
}
